export const EVENT_PAYMENT_UPDATE_INIT   = 'payment:update:init'

export const EVENT_PAYMENT_UPDATE_SUCCESS = 'payment:update:success'

export const EVENT_PAYMENT_DELETE_INIT   = 'payment:delete:init'